export const RESOURCE_MANAGEMENT_DATA = "RESOURCE_MANAGEMENT_DATA";
export const RESOURCE_MANAGEMENT_DATA_SUCCESS =
  "RESOURCE_MANAGEMENT_DATA_SUCCESS";
export const RESOURCE_MANAGEMENT_DATA_FAIL = "RESOURCE_MANAGEMENT_DATA_FAIL";

export const RESOURCE_MANAGEMENT_VIEW = "RESOURCE_MANAGEMENT_VIEW";
export const RESOURCE_MANAGEMENT_VIEW_SUCCESS =
  "RESOURCE_MANAGEMENT_VIEW_SUCCESS";
export const RESOURCE_MANAGEMENT_VIEW_FAIL = "RESOURCE_MANAGEMENT_VIEW_FAIL";

export const RESOURCE_MANAGEMENT_DELETE = "RESOURCE_MANAGEMENT_DELETE";
export const RESOURCE_MANAGEMENT_DELETE_SUCCESS = "RESOURCE_MANAGEMENT_DELETE_SUCCESS";
export const RESOURCE_MANAGEMENT_DELETE_FAIL = "RESOURCE_MANAGEMENT_DELETE_FAIL";
